<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn text v-bind="attrs" v-on="on">
        {{ selectedDistrictName }}
        <v-icon color="grey">mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, $i) in districts"
        :key="$i"
        @click="selectDistrict(item)"
      >
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { get } from 'vuex-pathify'
import districts from '@/common/districts'
import paramsDistrict from '@/common/paramsDistrict.js'

export default {
  name: 'DistrictSelect',

  data: () => ({
    districts
  }),

  computed: {
    selectedDistrictId: get('app/selectedDistrictId'),
    selectedDistrictName() {
      return this.districts.find(x => x.id === this.selectedDistrictId).name
    }
  },

  methods: {
    selectDistrict(item) {
      this.$store.set('app/selectedDistrictId', item.id)
      this.$store.dispatch('event/fetchStops')

      this.$store.dispatch('linkDeviation/fetchUnhandledCrewDeviations', {
        district_id: this.$store.get('app/selectedDistrictId')
      })
      if (item.id !== 21 && item.id !== 22) {
        this.$store.dispatch('linkDeviation/fetchUnhandledDelays', {
          district_id: this.$store.get('app/selectedDistrictId')
        })
        this.$store.dispatch('linkDeviation/fetchUnhandledTrainDeviations', {
          district_id: this.$store.get('app/selectedDistrictId')
        })
      }

      if (paramsDistrict(item.id) === this.$route.params.district_id) return
      this.$router.push(`/${paramsDistrict(item.id)}/event`)
    }
  }
}
</script>
